export default __webpack_public_path__ + "1ba3dcf27bc812cebf895e0af2360d9f.svg";